const ns = "FORMS_V2_SUBMISSIONS";
export const RECEIVE = `${ns}_RECEIVE`;
export const REQUEST = `${ns}_REQUEST`;
export const ERROR = `${ns}_ERROR`;
export const CLEAR_ERROR = `${ns}_CLEAR_ERROR`;
export const INVALIDATE = `${ns}_INVALIDATE`;
